(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/hoc/with-hero-content.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/hoc/with-hero-content.js');

'use strict';

const _excluded = ["overrides"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const Hero = svs.components.marketplaceCompetition.hero.Hero;
const useCompetitionId = svs.components.marketplaceCompetition.competitionContext.useCompetitionId;
const _svs$components$marke = svs.components.marketplaceCompetition.services.hooks,
  useCompetition = _svs$components$marke.useCompetition,
  useCompetitionBranding = _svs$components$marke.useCompetitionBranding;
const _svs$components$marke2 = svs.components.marketplaceCompetition.overviewHero.hooks,
  useContent = _svs$components$marke2.useContent,
  useUserState = _svs$components$marke2.useUserState;

const withHeroContent = () => _ref => {
  var _overrides$competitio;
  let _ref$overrides = _ref.overrides,
    overrides = _ref$overrides === void 0 ? {} : _ref$overrides,
    props = _objectWithoutProperties(_ref, _excluded);
  const competitionId = useCompetitionId();
  const competitionFromService = useCompetition(competitionId);

  const competition = overrides.competitionOverride || competitionFromService;
  const userState = useUserState({
    competition,
    overrides: overrides.userStateOverride ? {
      userState: overrides.userStateOverride
    } : {}
  });
  const branding = useCompetitionBranding(competition === null || competition === void 0 ? void 0 : competition.compType);
  const competitionStatus = (_overrides$competitio = overrides.competitionStatusOverride) !== null && _overrides$competitio !== void 0 ? _overrides$competitio : competition === null || competition === void 0 ? void 0 : competition.status;
  const extendedProps = _objectSpread(_objectSpread(_objectSpread({}, props), branding ? {
    branding
  } : {}), {}, {
    competitionId: competition === null || competition === void 0 ? void 0 : competition.id
  });

  const HeroContentComponent = useContent(competitionStatus);
  return (
    React.createElement(Hero, extendedProps, React.createElement(HeroContentComponent, {
      branding: branding,
      competition: competition,
      userState: userState
    }))
  );
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.hoc.withHeroContent', withHeroContent);

 })(window);